import { createSelector } from 'reselect'
import { IUserPreferences } from '../types/userPreferences'
import { AppStateType } from '../reducers'

export const selectUserPreferences = createSelector(
  [(state: AppStateType) => state.userPreferences],
  (userPreferences: IUserPreferences): IUserPreferences => userPreferences
)
